import { InterfaceStatus } from "../Enum/Status";
import { InfoText } from "../InfoText/InfoText";

export class LayerOverviewResponse {
  LayerGroup = new Array<LayerGroupInfo>();
  Status: InterfaceStatus = null;
}

export class LayerGroupInfo {
  Id: number = null;
  OrderId: number = null;
  LayerInfos = new Array<LayerInfo>();
  DisplayName = new Array<InfoText>();
  IsExpanded: boolean;
  Filters = new Array<LayerGroupInfoFilter>();
}

export class LayerInfo {
  Id: number = null;
  OrderId: number = null;
  LayerName: string = null;
  SingleLayer: boolean;
  DisplayName = new Array<InfoText>();
  DisplayInfoText = new Array<InfoText>();
  ShowInfoText: boolean;
  IsActivated: boolean;
  District: boolean;
  ColorRamp: boolean;
  FilterId: number = null;
  AvailableCountries: string[] = [];
}

export class LayerGroupInfoFilter {
  Id: number = null;
  IsActivated = false;
  DisplayName = new Array<InfoText>();
}
